export const LANGUAGES_BY_COUNTRY = {
  SWE: /en/,
  SE: /en/,
  DNK: /en/,
  DK: /en/,
  IRL: /en/,
  IE: /en/,
  FIN: /en|fi/,
  FI: /en|fi/,
  EST: /en|ee|ru|fi/,
  EE: /en|ee|ru|fi/,
  LVA: /.*/,
  LV: /.*/,
  NOR: /no|en/,
  NO: /no|en/,
  DEU: /de|en/,
  DE: /de|en/,
  BEL: /de|en/,
  BE: /de|en/,
  CHE: /de|en/,
  CH: /de|en/,
  AUT: /de|en/,
  AT: /de|en/,
  PL: /pl|en/,
  POL: /pl|en/,
  IT: /it|en/,
  ITA: /it|en/,
  FR: /fr|en/,
  FRA: /fr|en/,
  /**SL & SLE - wrong country code for Slovenia */
  SLE: /sl|en/,
  SL: /sl|en/,
  /**SI- correct country code for Slovenia */
  SI: /sl|en/,
};
